import { defineComponent as r, ref as u, watch as d, nextTick as m, openBlock as c, createElementBlock as f, normalizeClass as k, renderSlot as p, createElementVNode as v } from "vue";
const b = ["tabindex"], x = ["innerHTML"], I = /* @__PURE__ */ r({
  __name: "SelectItem",
  props: {
    label: { default: "" },
    active: { type: Boolean, default: !1 },
    idx: { default: -1 }
  },
  emits: ["click", "mouseover"],
  setup(o, { emit: s }) {
    const n = s, t = o, l = u(null);
    return d(
      () => t.active,
      (e) => {
        e && m(() => {
          l.value?.focus();
        });
      },
      { immediate: !0 }
    ), (e, i) => (c(), f("li", {
      ref_key: "liItem",
      ref: l,
      class: k(["uikit-list-none uikit-text-w-black", [
        { "active uikit-bg-w-cultured": e.active },
        "uikit-outline-none",
        e.$attrs.class
      ]]),
      tabindex: e.$attrs.tabindex ?? -1,
      onClick: i[0] || (i[0] = (a) => n("click", t.idx)),
      onMouseover: i[1] || (i[1] = (a) => n("mouseover", t.idx))
    }, [
      p(e.$slots, "default", { itemIdx: e.idx }, () => [
        v("span", {
          innerHTML: t.label
        }, null, 8, x)
      ])
    ], 42, b));
  }
});
export {
  I as _
};
